import Pqp from "../../../3x1010/Pqp.js";
import Anim from "./Anim.js";
import FramesPlayer from "./FramesPlayer.js";

export default class Spran {
	constructor(sp, clip, animationsDefinitions) {
		this.sp = sp;
		this.clip = clip;
		this.animationsDefinitions = animationsDefinitions;
		this.anims = new Array();
		this.fp = null;
		this.currentId = -1;
		this.pausedId = -1;
	}
	init() {
		let a = this.animationsDefinitions;
		for (let x = 0; x < a.length; x++) {
			let anm = new Anim(this.sp, a[x]);
			anm.init();
			this.anims.push(anm);
		}
	}

	setAnimation(id, callback) {
		if (!callback) {
			if (id === this.currentId) {
				return
			}
		}
		//console.log(id);
		this.currentId = id;
		let a = this.anims;
		for (let x = 0; x < a.length; x++) {
			if (a[x].id === id) {
				this.startAnimation(a[x],callback);
				break;
			}
		}
	}

	startAnimation(anim,callback) {
		if (this.fp) {
			this.fp.destroy();
		}
		this.fp = new FramesPlayer(this.clip, anim, this.eventsHandler.bind(this), callback);
		this.fp.start();
	}

	eventsHandler(e) {
		if (e.type === FramesPlayer.EVENT_GOTO_ANIMATION) {
			this.setAnimation(e.data.id);
		}
	}

	pause() {
		if (this.fp) {
			this.pausedId = this.currentId;
			this.currentId = -1;
			this.fp.destroy();
			this.fp = null;
		}
	}

	resume(animation = null) {
		if (!Pqp.isNullOrEmpty(animation)) {
			this.pausedId = animation;
		}

		if (!this.fp) {
			this.setAnimation(this.pausedId);
		}
	}


}